import React, { useContext, useRef } from "react";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";

export const GoalFormDropdown = ({
  selection,
  child,
  handleSelect,
  selectedItem,
  dropdownId,
}) => {
  const { t, uuid } = useContext(TMDataContext);
  var currentSelection = selection[child];
  const titleRef = useRef();
  const handleClick = (element) => {
    $(titleRef.current).children().first().text(element.label);
    var payload = currentSelection.find(
      (selected) => selected.id == element.currentTarget.value
    );
    handleSelect(payload);
  };
  const dropdownListMinimal = () => {
    if (currentSelection == null) {
      return null;
    } else {
      var dropdownList = currentSelection.map((element) => {
        return (
          <option key={uuid()} value={element.id} id={element.id}>
            {element.label}
          </option>
        );
      });

      return (
        <select
          className="goal-minimal-dropdown"
          name="conditions"
          ref={titleRef}
          value={selectedItem == null ? "" : selectedItem.id}
          onChange={(e) => {
            e.nativeEvent.stopImmediatePropagation();
            handleClick(e);
          }}
          id={dropdownId}
        >
          <option disabled value="">
            {t("views.goals.headings.select")}
          </option>
          {dropdownList}
        </select>
      );
    }
  };

  return dropdownListMinimal();
};
